import React, { useState,useRef } from "react";
import { baseURL } from '../Constant';
import axios from 'axios';
import { saveAs } from 'file-saver';
import {
  Container,
  TextField,
  Typography,
  Paper,
  RadioGroup,
  Radio,
  FormControlLabel,
  Box,
  Divider,
  Checkbox,
  LinearProgress,
  IconButton
} from "@mui/material";
import './Design.css';
import ImageIcon from '@mui/icons-material/Image';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Alert from '@mui/material/Alert';

const options = {
  dimensions:[
    { label: "512X512", value: "512x512"},
    { label: "1920X400", value: "1920x400"},
    { label: "Custom", value: "custom"},
  ],
  orientation:[
    { label: "Portrait", value: "1024x1792" },
    { label: "Landscape", value: "1792x1024" },
    { label: "Square", value: "1024x1024" },
  ],
  format:[
    { label: "JPG", value: "jpg" },
    { label: "PNG", value: "png" },
    { label: "SVG", value: "svg" },
  ],
  style:[
    { label: "Photo", value: "photo"},
    { label: "Art", value: "art" },
    { label: "Dark", value: "dark" },
    { label: "Illustration", value: "illustration" },
    { label: "2D", value: "2d" },
    { label: "3D", value: "3d" },
    { label: "Cartoon", value: "cartoon" },
    { label: "Comic", value: "comic" },
    { label: "Pencil", value: "pencil" },
  ]
};

const ChatApp = () => {
  const [messages, setMessages] = useState([
    // { text: "Hello!", sender: "bot" },
    // { text: "Hi there! ", sender: "user" },
  ]);

  const [generatedImage, setGeneratedImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorAlert, setErrorAlert] = useState('');
  const [input, setInput] = useState("");
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [dragging, setDragging] = useState(false);

  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setPreview(URL.createObjectURL(file));
    }
  };

    const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => setDragging(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      setPreview(URL.createObjectURL(file));
    }
  };

  async function generateImage() {

    const prompt = input.trim();
    setInput('');
     if (!prompt) {return;}

    setMessages([{ text: prompt, sender: "user"}]);
    setLoading(true);

    try {
       let res = await axios.post(`${baseURL}/genImage`, {
        prompt: prompt,
        imgColor: `background color is ${specs.backgroundColor} and foreground color is ${specs.foregroundColor}`,
        typeOfImage: specs.style,
        imgOrientation: specs.orientation
      });
      setMessages([{ text: prompt, sender: "user"}, { text: res.data.data, sender: "bot"}]);
    } catch (error) {      
      setErrorAlert("Unable to generate image! Please try again later.");
      setTimeout(()=>setErrorAlert(""), 3500);
    }finally{
      setLoading(false);
    }
  }

  const handleDownload = (currentImg) => {
    const imageUrl = currentImg;
    fetch(imageUrl || "")
      .then((response) => response.blob())
      .then((blob) => {
        saveAs(blob, 'genImage.jpg');
      })
      .catch((err) => console.log('err', err));
  };


  const [specs, setSpecs] = useState({
    dimensions: "512x512",
    orientation: "1024x1024",
    format: "jpg",
    style: "illustration",
    backgroundColor:'#460073',
    foregroundColor:'#cfcfcf'
  });

  const [usingDefaults, setUsingDefaults]= useState(true);

  const reset_to_defaults=()=>{
    setSpecs({
    dimensions: "512x512",
    orientation: "square",
    format: "jpg",
    style: "illustration",
    backgroundColor:'#460073',
    foregroundColor:'#cfcfcf'
  });
  setUsingDefaults(true);
  }

  const handleChange = (property, value) => {
  setSpecs((prev) => ({
    ...prev,
    [property]: value,
  }));
  setUsingDefaults(false);
};

  return (
    <Container className="playground">
      <Box>
        {/* Chat Area */}
        <Box className="chat-area">
      
          {messages.length>0?
          // Messages 
          <Paper>
            {messages.map((msg, index) => (
              <Box
                key={index}
                className={`message-row ${msg.sender === "user" ? "flex_start" : "flex_end"}`}
              >
                {msg.sender !== "user" &&
                   <img 
                    src={process.env.PUBLIC_URL + "/Images/comms_icon.png"}
                    height="25px"
                    width="25px"
                    alt="commsbuilderIcon" />
                }
                <Box  className={`message ${msg.sender === "user" ? "message-user" : "message-bot"}`}>
                  {msg.sender==="user"?
                  msg.text:
                  <div className="image-container">
                  <img
                    style={{
                     maxWidth: "420px",
                     height: "auto",
                     objectFit: "contain"
                    }}
                     crossOrigin="anonymous" 
                     src={msg.text}
                     alt="Image"
                  />
                      <span className='top-right-btn'>
                        <FileDownloadIcon onClick={() => handleDownload(msg.text)} className="download-icon" titleAccess='Download' />
                      </span>
                   </div>
                  }
                </Box>
              </Box>
            ))}
          </Paper>:
          <Box className="no-msgs">
           <img 
            src={process.env.PUBLIC_URL + "/Images/comms_icon.png"}
            height="70px"
            width="70px"
            alt="commsbuilderIcon"  />
           <Typography variant='h4' 
           sx={{
            fontFamily:"graphik-semibold",
            fontSize:"25px"
            }}>
              Start Generating Images
           </Typography>
            <Typography>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus, consequatur!
            </Typography>
          </Box>
          }
          {errorAlert &&
          <div style={{margin:"3px"}}>
          <Alert severity="warning" onClose={() => setErrorAlert("")}>
           {errorAlert}
          </Alert>
          </div>
          }
          
          {/* Input */}
          <Box className="input">
             <Box 
              className="textNimage-container"
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              >

            <TextField
              fullWidth
              multiline
              rows={3}
              variant="standard"
              placeholder="Describe the image you want to generate"
              InputProps={{ disableUnderline: true }}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && generateImage()}
            />
           <Divider orientation="vertical" flexItem className="upload-divider" />
          <Box className="upload-right" onClick={!preview ? handleFileClick : undefined}>
            {preview ? (
              <div className="preview-container">
                <img src={preview} alt="preview" className="upload-preview" />
                <CloseIcon
                  size="small"
                  className="remove-preview-icon"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering upload click
                    setPreview(null);
                  }}
                />
              </div>
            ) : (
              <>
                <ImageIcon className="upload-icon" />
                <Typography variant="body2" className="upload-text">
                  Drag & Drop
                  <br />
                  OR
                  <br />
                  Upload
                </Typography>
              </>
            )}

            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
          </Box>
          </Box>
            {loading? <LinearProgress className="loader"/>
              :
            <div className="generate-btn" onClick={generateImage}>
              <img
                src={process.env.PUBLIC_URL + "/Images/comms_icon.png"}
                height="35px"
                width="35px"
                alt="generateIcon"
                style={{ display: "block" }} // Removes small spacing under image
                />
              <span>Generate&nbsp;</span>
            </div>
              }

          </Box>
        </Box>

        {/* Sidebar */}
        <Box className="sidebar" sx={{boxShadow:2}}>
          <Typography variant="h4" id="heading">Specifications</Typography>
           {/* <-- DIMENSIONS--> */}
            <Box>
              <Typography className="sub-head">Dimension</Typography>
              <RadioGroup
                row
                value={specs.dimensions}
                onChange={(e) => handleChange("dimensions", e.target.value)}
                sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
              >
                {options.dimensions.map((option, index) => (
                  <React.Fragment key={option.value}>
                    {index !== 0 && (
                      <Divider orientation="vertical" flexItem sx={{
                        borderRight: '1px dotted #ccc',
                        height: 'auto',
                        mx: 1,
                        bgcolor: 'transparent'
                      }}/>
                    )}
                    <FormControlLabel
                      value={option.value}
                      label={option.label}
                      labelPlacement="bottom"
                      control={<Radio className="custom-radio"/>}
                      className="custom-form-control-label"
                    />
                  </React.Fragment>
                ))}
              </RadioGroup>
            </Box>
            <Divider/>
           {/* <-- ORIENTATION--> */}
            <Box>
              <Typography className="sub-head">Orientation</Typography>
              <RadioGroup
                row
                value={specs.orientation}
                onChange={(e) => handleChange("orientation", e.target.value)}
              >
                {options.orientation.map((option, index) => (
                  <React.Fragment key={option.value}>
                    <FormControlLabel
                      value={option.value}
                      label={option.label}
                      labelPlacement="bottom"
                      control={<Radio className="custom-radio" />}
                      className="custom-form-control-label"
                    />
                  </React.Fragment>
                ))}
              </RadioGroup>

            </Box>
            <Divider />
            {/* <-- FORMAT--> */}
            <Box>
            <Typography className="sub-head">Format</Typography>
            <RadioGroup
              row
              value={specs.format}
              onChange={(e) => handleChange("format", e.target.value)}
            >
              {options.format.map((option, index) => (
                <React.Fragment key={option.value}>
                  <FormControlLabel
                    value={option.value}
                    label={option.label}
                    labelPlacement="bottom"
                    control={<Radio className="custom-radio" />}
                    className="custom-form-control-label"
                  />
                </React.Fragment>
              ))}
            </RadioGroup>
            </Box>
            <Divider />
            {/* <-- STYLE--> */}
            <Box>
            <Typography className="sub-head">Style</Typography>
            <RadioGroup
              row
              value={specs.style}
              onChange={(e) => handleChange("style", e.target.value)}
            >
              {options.style.map((option, index) => (
                <React.Fragment key={option.value}>
                  <FormControlLabel
                    value={option.value}
                    label={option.label}
                    labelPlacement="bottom"
                    control={<Radio className="custom-radio" />}
                    className="custom-form-control-label"
                  />
                </React.Fragment>
              ))}
            </RadioGroup>
            </Box>
            <Divider />
            {/* <-- COLOR--> */}
            <Box>
            <Typography className="sub-head">Color</Typography>
              <div>
              <span style={{color:"#002B9E", fontSize:"13px"}}>Background:&nbsp;</span>
              <input
                type="color"
                value={specs.backgroundColor}
                onChange={(e) => handleChange("backgroundColor",e.target.value)}
                style={{
                width: "17px",
                height: "19px",
                padding: 0,
                border: "none",
                background: "none",
                cursor: "pointer",
                }}
              />
              <span style={{fontSize:"12px"}}>{specs.backgroundColor}</span>
              </div>
              <div>
                <span style={{color:"#002B9E", fontSize:"13px"}}>Foreground:&nbsp;</span>
                 <input
                  type="color"
                  value={specs.foregroundColor}
                  onChange={(e) => handleChange("foregroundColor",e.target.value)}
                  style={{
                    width: "17px",
                    height: "19px",
                    padding: 0,
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                  }}
                />
                <span style={{fontSize:"12px"}}>{specs.foregroundColor}</span>
              </div>
            </Box>
            
          <FormControlLabel
            control={
             <Checkbox
              checked={usingDefaults}
              onChange={reset_to_defaults}
              defaultChecked 
              sx={{
              color: "#9F00FF",
              '&.Mui-checked': {
              color: "#9F00FF",
              },
              }}
              size="small"/>
            }
            label="Use Default theme"
            className="reset-checkbox-label"
          />

        </Box>
      </Box>
    </Container>
  );
};

export default ChatApp;
